export default __webpack_public_path__ + "static/sign-up-image-b4fdd908cb3a152c3f12571aae5dd6c0.jpg";